import React from 'react';

const CurrentBasketInfo = ({ basket }) => {
  if (!basket) return null;

  const topicCount = basket.topics?.length || 0;

  const getContrastColor = (hexColor) => {
    hexColor = hexColor.replace('#', '');
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
  };

  return (
    <div className="px-4 py-3 bg-white">
      <h3 className="text-base font-semibold text-neutral-700">{basket.name}</h3>
      <p className="text-xs text-neutral-500 mt-1">
        {topicCount} item{topicCount !== 1 ? 's' : ''}
        {topicCount > 0 && (
          <>
            {' • '}
            {basket.topics.map((topic, index) => (
              <React.Fragment key={topic.id}>
                {index > 0 && ' '}
                <span 
                  className="inline-block rounded-full px-2 py-0.5 text-xs font-medium"
                  style={{
                    backgroundColor: topic.tag?.color || '#E6E6FF',
                    color: getContrastColor(topic.tag?.color || '#E6E6FF')
                  }}
                >
                  {topic.name}
                </span>
              </React.Fragment>
            ))}
          </>
        )}
      </p>
    </div>
  );
};

export default CurrentBasketInfo;
